module.exports = __webpack_public_path__ + "img/farming_25.9eb32a35.png";